import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DropdownModule } from "primeng/dropdown";
import { CardModule } from "primeng/card";
import { BadgeModule } from "primeng/badge";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MenubarModule } from "primeng/menubar";
import { ImageModule } from "primeng/image";
import { TagModule } from "primeng/tag";
import { DialogModule } from "primeng/dialog";
import { InputSwitchModule } from "primeng/inputswitch";
import { RadioButtonModule } from "primeng/radiobutton";
import { ProgressSpinnerModule } from "primeng/progressspinner";

const importExportLin = [
  DropdownModule,
  CardModule,
  BadgeModule,
  TableModule,
  ButtonModule,
  MenubarModule,
  ImageModule,
  TagModule,
  DialogModule,
  InputSwitchModule,
  RadioButtonModule,
  ProgressSpinnerModule,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, ...importExportLin],
  exports: [...importExportLin],
})
export class PrimengModule {}
